import { render, staticRenderFns } from "./Reject.vue?vue&type=template&id=4b510f3e&scoped=true"
import script from "./Reject.vue?vue&type=script&lang=ts"
export * from "./Reject.vue?vue&type=script&lang=ts"
import style0 from "./Reject.vue?vue&type=style&index=0&id=4b510f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b510f3e",
  null
  
)

export default component.exports